/*
 * @Author: zhangxiaofeng
 * @Date: 2020-04-17
 * @LastEditors: zhangxiaofeng
 * @LastEditTime: 2020-04-17
 * @Description: file content
 */
/**
 * @Description: 路由配置
 * @Date: 2020-04-17
 * @Modify:
 * @Author: zhangxiaofeng
 */
const arr = path => [
  {
    path: path, // 项目列表
    redirect: `${path}/list`,
    name: 'prjList', // 项目列表
    component: () => import('@/views/project/children/List'),
    meta: { title: '项目库', icon: 'home', noCache: true, keepAlive: false, auth: true }
  },
  {
    path: `${path}/list`, // 项目列表
    name: 'prjList', // 项目列表
    component: () => import('@/views/project/children/List'),
    meta: { title: '项目库', icon: 'home', noCache: true, keepAlive: false, auth: true }
  },
  {
    path: `${path}/:id`, // 项目详情
    redirect: `${path}/:id/files/:status?`,
    component: () => import('@/views/project/children/detail/Index'),
    children: [
      {
        path: 'info/', // 项目信息
        name: 'prjInfo',
        component: () => import('@/views/project/children/detail/children/Info'),
        meta: { title: '项目库', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'files/:status?', // 项目文件
        name: 'prjFiles',
        component: () => import('@/views/project/children/detail/children/Files'),
        meta: { title: '项目库', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'members', // 项目成员
        name: 'prjMembers',
        component: () => import('@/views/project/children/detail/children/Members'),
        meta: { title: '项目库', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'recycle', // 项目回收站
        name: 'prjRecycle',
        component: () => import('@/views/project/children/detail/children/Recycle'),
        meta: { title: '项目库', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'logs', // 项目操作详情
        name: 'prjLogs',
        component: () => import('@/views/project/children/detail/children/Logs'),
        meta: { title: '项目库', icon: 'home', noCache: true, keepAlive: false, auth: true }
      }
    ]
  }
]
export default [
  {
    path: '/proj_guide',
    name: 'project_guide_page',
    component: () => import('@/views/project/Guide')
  },
  {
    path: '/project',
    name: 'project',
    component: () => import('@/components/layout/Index.vue'),
    children: [
      ...arr('all').concat(arr('joined')).concat([{
        path: 'add', // 创建项目
        name: 'prjAdd',
        component: () => import('@/views/project/children/Add'),
        meta: { title: '项目库', icon: 'home', noCache: true, keepAlive: false, auth: true }
      }]),
      {
        path: 'database',
        component: () => import('@/views/database/children/data/Record.vue'),
        meta: { title: '电子备案库', icon: 'home', noCache: true, keepAlive: false, auth: true }
      }
    ]
  }
]
